"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Mustache = require('mustache');

var Exceed =
/*#__PURE__*/
function () {
  function Exceed(config) {
    _classCallCheck(this, Exceed);

    config = config || {};
    var finalConfig = config;
    finalConfig.ENV = finalConfig.ENV || 'production';

    finalConfig.validateStatus = finalConfig.validateStatus || function (status) {
      return status >= 200 && status < 300 || status === 401 || status === 400;
    }; // 组合为最终配置


    this.config = finalConfig;
    this.apimap = [];
    this.axios = _axios["default"].create({
      timeout: finalConfig.timeout || 3000,
      withCredentials: true,
      validateStatus: finalConfig.validateStatus
    });
    this.interceptors = this.axios.interceptors;
  }

  _createClass(Exceed, [{
    key: "use",
    value: function use(apimap) {
      if (apimap instanceof Array) {
        this.apimap = apimap;
      } else {
        console && console.warn && console.warn("can not found ENV:".concat(this.config.ENV, " in your apimap"));
      }
    }
  }, {
    key: "fetch",
    value: function fetch(param) {
      var _this = this;

      var requestParams;

      if (typeof param === 'string') {
        param = {
          api: param
        };
      }

      this.apimap.forEach(function (item) {
        if (item.id === param.api) {
          // 如果存在 params 字段则调用胡子插件进行字符串模板渲染
          if (param.params) {
            var url = item.urls[_this.config.ENV];
            item.url = Mustache.render(url, param.params);
          } else {
            item.url = item.urls[_this.config.ENV];
          }

          requestParams = item;
        }
      });

      if (!requestParams) {
        console && console.warn && console.warn("can not found API:".concat(param.api, " in your current environment"));
      } // 添加通用参数


      if (!requestParams.url) {
        console.warn('API url is null, please check the APIMAP');
      } // 将访问数据添加进requestParams中


      if (param.data) {
        requestParams.data = param.data;
      }

      requestParams.data = requestParams.data || {};

      if (requestParams.method === 'get' || requestParams.method === 'GET') {
        var arr = Object.keys(requestParams.data);
        arr.forEach(function (item, index) {
          if (index === 0 && requestParams.url.indexOf('?') === -1) {
            requestParams.url += "?".concat(item, "=").concat(requestParams.data[item]);
          } else {
            requestParams.url += "&".concat(item, "=").concat(requestParams.data[item]);
          }
        });
      }

      if (requestParams.url.indexOf('?') === -1) {
        requestParams.url += '?';
      } else {
        requestParams.url += '&';
      }

      requestParams.url += '_input_charset=utf-8';
      return this.axios.request(requestParams);
    }
  }]);

  return Exceed;
}();

var _default = Exceed;
exports["default"] = _default;